import { render, staticRenderFns } from "./cobranzas.vue?vue&type=template&id=5b967c48"
import script from "./cobranzas.vue?vue&type=script&lang=js"
export * from "./cobranzas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports